import type { HttpClient } from '../http/HttpClient'
import { mapBudgetDistribution, type RawBudgetDistribution } from './mapBudgetDistribution'
import type {
  BudgetDistribution,
  BudgetDistributionRepository,
  DistributionDocType,
  DistributionPayload,
} from '@/domain/budgetDistribution/BudgetDistribution'

export class HttpBudgetDistributionRepository implements BudgetDistributionRepository {
  constructor(private readonly http: HttpClient) {}

  async save(
    docType: DistributionDocType,
    id: number,
    payload: DistributionPayload,
    options: { dryRun: boolean },
  ): Promise<BudgetDistribution> {
    const request = this.http.url(`budgets/distribution/${docType}/${id}`).body(
      payload.fromMilestones
        ? { from_milestones: true, period_type: payload.periodType }
        : {
            input_mode: payload.inputMode,
            period_type: payload.periodType,
            rows: payload.rows.map((row) => ({ period_start: row.periodStart, value: String(row.value) })),
          },
    )
    if (options.dryRun) request.params({ dry_run: 'true' })
    return mapBudgetDistribution(await request.put<RawBudgetDistribution>())
  }

  async followSource(docType: DistributionDocType, id: number): Promise<BudgetDistribution> {
    const raw = await this.http.url(`budgets/distribution/${docType}/${id}`).body({ follow_source: true }).put<RawBudgetDistribution>()
    return mapBudgetDistribution(raw)
  }
}
